import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'app-document-number-info',
  templateUrl: './document-number-info.component.html',
  styleUrls: ['./document-number-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentNumberInfoComponent implements OnInit {
  @Input() documentType: string;
  @Input() documentNumber: string;

  constructor() {}

  ngOnInit() {}
}
